import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { openCancelBackgroundJobDialogAction } from '../../app/actions/spaces/OpenCancelBackgroundJobDialogAction';
import { Messages } from '../../codegen/Localize';
import { ICancelBackgroundJobAction } from '../../ts/ServerApi/types/actionNames';
import { IBackgroundJobInfo } from '../types/BackgroundJobs';

// Confusingly, the UI cancel background job action does not map directly to the redux action, as the UI
// prompts the user for details and confirmation, whilst the redux action simply executes the cancellation
export const CancelBackgroundJobAction: IEntityAction<IBackgroundJobInfo, ICancelBackgroundJobAction> = {
  name: EntityActionNames.CancelBackgroundJob,
  translateName: Messages.cancel,
  isVisible: () => true, // probably need to do something here
  isClickable: (availableActions: ICancelBackgroundJobAction) => !!(availableActions && availableActions.cancelBackgroundJob),
  createReduxAction: (targetItems: IBackgroundJobInfo[]) => openCancelBackgroundJobDialogAction(targetItems[0])
};
